export default "__VITE_ASSET__0f5f591f__"